import { Injectable, Injector } from "@angular/core";
import { Constants } from "./common.const";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { CookieService } from "./cookies";
import { Router } from "@angular/router";
import { Subject } from "rxjs/Subject";
import { UserRolesService } from "./user-roles.service";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class CommonService extends Constants {
  constructor(
    private sessionStorageService: SessionStorageService,
    private cookie: CookieService,
    private authService: AuthService,
    private injector: Injector
  ) {
    super();
  }

  public get router(): Router {
    //this creates router property on your service.
    return this.injector.get(Router);
  }

  private logOutCalledSource = new Subject<any>();
  logOutCalled$ = this.logOutCalledSource.asObservable();
  callLogout(logoutType: any) {
    this.logOutCalledSource.next();
  }
  setCookieExpire(cname, cvalue, seconds) {
    var d = new Date();
    d.setTime(d.getTime() + seconds * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  campaignRequest = {
    dfsCommonServiceRequest: {
      channelId: 22,
      clientTransactionId: Math.floor(Date.now()),
      entityId: this.getStorage("userInfo.entityId"),
      initiatorMsisdn: 0,
      requestId: Math.floor(Date.now()),
      surroundSystem: 0,
      timestamp: Math.floor(Date.now()),
    },
    dfsRequestInfo: {},
  };
  get token() {
    return this.getStorage(this._token);
  }

  set token(tok: string) {
    this.setStorage(this._token, tok);
  }

  stringParams(params: any): string {
    let x = [];
    for (let k in params) x.push(k + "=" + params[k]);
    return x.join("&");
  }

  setStorage(key, value): any {
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }
  getStorage(key): any {
    const x = localStorage.getItem(key);
    try {
      const xx = JSON.parse(x);
      return xx;
    } catch (e) {
      return x;
    }
  }
  removeStorage(key): any {
    localStorage.removeItem(key);
  }
  removeAllStorage(): any {
    localStorage.clear();
  }
  setSessionStorage(key, value): any {
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  }
  getSessionStorage(key): any {
    const x = sessionStorage.getItem(key);
    try {
      const xx = JSON.parse(x);
      return xx;
    } catch (e) {
      return x;
    }
  }
  removeSessionStorage(key): any {
    sessionStorage.removeItem(key);
  }
  removeAllSessionStorage(): any {
    sessionStorage.clear();
  }

  setCookie(key, value, options?): any {
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }
    this.cookie.put(key, value, options);
  }
  getCookie(key): any {
    const x = this.cookie.get(key);
    try {
      const xx = JSON.parse(x);
      return xx;
    } catch (e) {
      return x;
    }
  }
  removeCookie(key, options?): any {
    this.cookie.remove(key, options);
  }
  removeAllCookie(): any {
    this.cookie.removeAll();
  }

  findObjectById(json: any, key: any, id: any) {
    if (key.split(".").length > 1) {
      // for nested object
      let a = [];
      for (let d of key.split(".")) {
        a.push("['" + d + "']");
      }
      return json.filter(function (o) {
        console.log(eval("o" + a.join("")));
        return eval("o" + a.join("")) == id;
      })[0];
    } else {
      return json.filter(function (o) {
        return o[key] == id;
      })[0];
    }
  }
  findIndexById(json: any, key: any, id: any): any {
    json.indexOf(this.findObjectById(json, key, id));
  }

  updateAccessInfo(userInfo): any {
    this.authService.authModules = [];

    userInfo["walletManagement"] = userInfo.access["walletManagement"];
    this.authService.authModules.push({
      access: userInfo["walletManagement"],
      path: "main/wallet-management",
    });

    userInfo["userGroupManagement"] = userInfo.access["userGroupManagement"];
    this.authService.authModules.push({
      access: userInfo["userGroupManagement"],
      path: "main/user-group-management",
    });

    userInfo["serviceManagement"] = userInfo.access["serviceManagement"];
    this.authService.authModules.push({
      access: userInfo["serviceManagement"],
      path: "main/service-management",
    });

    userInfo["serviceGroupManagement"] =
      userInfo.access["serviceGroupManagement"];
    this.authService.authModules.push({
      access: userInfo["serviceGroupManagement"],
      path: "main/service-group-management",
    });

    userInfo["ruleSetManagement"] = userInfo.access["ruleManagement"];
    this.authService.authModules.push({
      access: userInfo["ruleSetManagement"],
      path: "main/rule-set-management",
    });

    userInfo["limitCappingManagement"] = userInfo.access["limitsAndCapping"];
    this.authService.authModules.push({
      access: userInfo["limitCappingManagement"],
      path: "main/limits-capping-management",
    });

    userInfo["hierarchyManagement"] = userInfo.access["hierarchyManagement"];
    this.authService.authModules.push({
      access: userInfo["hierarchyManagement"],
      path: "main/hierarchy-management",
    });

    userInfo["loginManagement"] = userInfo.access["loginManagement"];
    this.authService.authModules.push({
      access: userInfo["loginManagement"],
      path: "main/login-management",
    });

    userInfo["promotionalCampaigns"] = userInfo.access["promotionalCampaigns"];
    this.authService.authModules.push({
      access: userInfo["promotionalCampaigns"],
      path: "main/promotionalCampaigns",
    });

    userInfo["biller"] = userInfo.access["billerManagement"];
    this.authService.authModules.push({
      access: userInfo["biller"],
      path: "main/biller",
    });

    userInfo["promocodeManagement"] = userInfo.access["promocodeManagement"];
    this.authService.authModules.push({
      access: userInfo["promocodeManagement"],
      path: "main/promo-code-management",
    });

    userInfo["reports"] = userInfo.access["reports"];
    this.authService.authModules.push({
      access: userInfo["reports"],
      path: "main/reports",
    });

    userInfo["operations"] = userInfo.access["operations"];
    this.authService.authModules.push({
      access: userInfo["operations"],
      path: "main/operations",
    });

    userInfo["brms"] = userInfo.access["brmsTestPad"];
    this.authService.authModules.push({
      access: userInfo["brms"],
      path: "main/brms",
    });

    userInfo["notification"] = userInfo.access["notificationManagement"];
    this.authService.authModules.push({
      access: userInfo["notification"],
      path: "main/notification",
    });

    userInfo["cashInManager"] = userInfo.access["cashInManagement"];
    this.authService.authModules.push({
      access: userInfo["cashInManager"],
      path: "main/cash-in-manager",
    });

    userInfo["kyc"] = userInfo.access["kycReq"];
    this.authService.authModules.push({
      access: userInfo["kyc"],
      path: "main/kyc",
    });

    userInfo["agentRequests"] = userInfo.access["agentRequest"] || userInfo.access["agentrequest"] || userInfo.access["agentRequests"];
    if (userInfo["agentRequests"]) {
      this.authService.authModules.push({
        access: userInfo["agentRequests"],
        path: "main/agent-requests",
      });
    }

    userInfo["fundTransfer"] = userInfo.access["fundTransfer"];
    this.authService.authModules.push({
      access: userInfo["fundTransfer"],
      path: "main/fund-transfer/debit-credit",
    });

    userInfo["groupLimitManagement"] =
      userInfo.access["groupLimitManagement"] ||
      userInfo.access["globalLimitManagement"];
    if (userInfo["groupLimitManagement"]) {
      this.authService.authModules.push({
        access: userInfo["groupLimitManagement"],
        path: "main/globalLimitManagement",
      });
    }

    userInfo["sendMoney"] = userInfo.access["sendMoney"];
    userInfo["withdrawMoney"] = userInfo.access["withdrawMoney"];

    userInfo["settlement"] = userInfo.access["settlements"] || userInfo.access["settlement"] || userInfo.access["settlementManagement"];
    userInfo["settlements"] = userInfo["settlement"];
    this.authService.authModules.push({
      access: userInfo["settlement"],
      path: "main/Settlement",
    });

    userInfo["transaction"] = userInfo.access["transaction"] || userInfo.access["transactionManagement"] || "";
    this.authService.authModules.push({
      access: userInfo["transaction"],
      path: "main/transaction",
    });

    userInfo["bankRequests"] = userInfo.access["bankRequests"] || userInfo.access["bankRequest"] || userInfo.access["bankrequest"] || "";
    this.authService.authModules.push({
      access: userInfo["bankRequests"],
      path: "main/bank-requests",
    });

    delete userInfo["access"];
    return userInfo;
  }

  getModulePath() {
    let path = ["auth/login"];
    if (
      !this.authService.authModules ||
      this.authService.authModules.length === 0
    ) {
      return ["main/no-permission"];
    }

    let hasAccess = false;
    for (let index = 0; index < this.authService.authModules.length; index++) {
      if (
        this.authService.authModules[index].access !== "H" &&
        this.authService.authModules[index].access !== null
      ) {
        path[0] = this.authService.authModules[index].path;
        hasAccess = true;
        break;
      }
    }

    if (!hasAccess) {
      return ["main/no-permission"];
    }

    return path;
  }

  getUserInfo() {
    //var x = this.getStorage(this.loginConst.userInfoObj);
    var x = this.authService.userInfo;
    //  console.log('common  service ---------1'+ this.authService.userInfo);
    //  console.log('common  service ---------2'+ JSON.stringify(this.authService.userInfo));

    try {
      do {
        x = JSON.parse(x);
      } while (typeof x != "object");
    } catch (e) { }
    if (x) {
      if (Array.isArray(x["object"])) {
        return x["object"][0];
      } else if (x["object"] != null && typeof x["object"] == "object") {
        return x["object"];
      } else if (x["object"] == null && typeof x == "object") {
        return x;
      }
    }
    return {};
  }
  getUserId() {
    let obj = this.getUserInfo();
    for (let o of this.loginConst.userIdFormats) {
      if (obj[o] != null) {
        return obj[o] + "-" + obj.userName;
      }
    }
    return obj.userName;
  }
  getEntityId() {
    let obj = this.getUserInfo();
    for (let o of this.loginConst.userIdFormats) {
      if (obj[o] != null) {
        return obj[o] + "-" + obj.entityId;
      }
    }
    return obj.entityId;
  }
  logout() {
    var s1 = document.querySelector("ngb-modal-backdrop");
    if (s1) s1.remove();
    var s2 = document.querySelector("ngb-modal-window");
    if (s2) s2.remove();
    this.removeAllSessionStorage();
    this.removeAllStorage();
    this.authService.userInfo = {};
    document.cookie = "_ctuid=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    this.router.navigate(["/auth/login"]);
  }
  sendResponse(status, data?: any) {
    return {
      status: status,
      data: data,
    };
  }
  removeStringRegexLimitation(regString: any) {
    let f = regString,
      stp = "{",
      enp = "}",
      i = 0,
      haveP = true;
    do {
      let lp = f.lastIndexOf(enp);
      if (lp != -1) {
        let newF = f.slice(0, lp);
        let sp = newF.lastIndexOf(stp);
        f = f.slice(0, sp) + f.slice(lp + 1);
      } else {
        haveP = false;
      }
    } while (haveP && i == 1);

    return f;
  }

  changeCaseAllKeys(array, caseType) {
    for (var i = 0; i < array.length; i++) {
      if (Array.isArray(array[i])) {
        this.changeCaseAllKeys(array[i], caseType);
      } else if (array[i] != null && typeof array[i] == "object") {
        array[i] = allKeysToCase(array[i], caseType);
      }
    }
    return array;
  }

  camelCaseToUpperCaseUnderScore(array) {
    for (var i = 0; i < array.length; i++) {
      if (Array.isArray(array[i])) {
        this.camelCaseToUpperCaseUnderScore(array[i]);
      } else if (array[i] != null && typeof array[i] == "object") {
        array[i] = camelCaseToUpperCaseUnderScore(array[i]);
      }
    }
    return array;
  }

  changeEmptyValueToSpecificValue(obj, value = "0") {
    return changeEmptyValueToSpecificValue(obj, value);
  }

  downloadFile(data, fileExtention, fileName?) {
    let a: any = document.createElement("a");
    a.style = "display: none";
    let date = new Date();
    let Tdate =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    if (fileName) {
      a.download = fileName;
    }
    a.href = window.URL.createObjectURL(data);
    a.textContent = "Download CSV";
    a.dataset.downloadurl = [fileExtention, a.download, a.href].join(":");
    document.body.appendChild(a);
    setTimeout(() => {
      a.click();
      a.remove();
    }, 1000);
  }

  downloadFileFormats = {
    csv: "text/csv;charset=ISO-8859-1",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  };

  getRequestId(): any {
    return Math.floor(Math.random() * 100 + 1) + Math.floor(Date.now());
  }
}

function allKeysToCase(obj, caseType) {
  var output = {};
  for (var i in obj) {
    if (Object.prototype.toString.apply(obj[i]) === "[object Object]") {
      output[i.toUpperCase()] = allKeysToCase(obj[i], caseType);
    } else {
      output[i.toUpperCase()] = obj[i];
    }
  }
  return output;
}
function camelCaseToUpperCaseUnderScore(obj) {
  var object = {};
  for (var key in obj) {
    object[camelCaseToUpperCaseUnderScoreKey(key)] = obj[key];
  }
  return object;
}
function camelCaseToUpperCaseUnderScoreKey(string) {
  var final = [];
  var array = string.split("");
  for (var s of array) {
    if (s == s.toUpperCase()) {
      final.push("_");
    }
    final.push(s.toUpperCase());
  }
  return final.join("");
}

function changeEmptyValueToSpecificValue(obj, value = "0") {
  if (Array.isArray(obj)) {
    for (let d of obj) {
      d = changeEmptyValueToSpecificValue(d, value);
    }
  } else if (typeof obj == "object") {
    for (var x in obj) {
      if (obj[x] && (Array.isArray(obj) || typeof obj[x] == "object")) {
        obj[x] = changeEmptyValueToSpecificValue(obj[x], value);
      } else {
        if (obj[x] == null || obj[x] == "") {
          obj[x] = value;
        }
      }
    }
  } else if (obj == null || obj == "") {
    obj = value;
  }
  return obj;
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/common.service.ts